export async function getImageDimensions(
  file: File,
): Promise<{ width: number; height: number }> {
  const image = await createImageBitmap(file);

  return { width: image.width, height: image.height };
}
